import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getStorageLng } from "./storage";
import { i18n_langs, getBrowserLang } from "./config";

import enUS from "./locales/en-US/translation.json";
import zhCN from "./locales/zh-CN/translation.json";
import zhHK from "./locales/zh-HK/translation.json";
import ruRU from "./locales/ru-RU/translation.json";
import trTR from "./locales/tr-TR/translation.json";
import jaJP from "./locales/ja-JP/translation.json";
import frFR from "./locales/fr-FR/translation.json";
import deDE from "./locales/de-DE/translation.json";
import esES from "./locales/es-ES/translation.json";
import hiIN from "./locales/hi/translation.json"; // or hi-IN
import viVI from "./locales/vi-VI/translation.json";
import koKR from "./locales/ko-KR/translation.json";
import plPL from "./locales/pl-PL/translation.json";

// 统一语言代码格式
const transformLangCode = (code = "en-us") => {
  const [lang, region] = code.split("-");
  return region
    ? `${lang.toLowerCase()}-${region.toUpperCase()}`
    : lang.toLowerCase();
};

// 语言代码列表建议统一大写：en-US、zh-CN...
const resources = {
  "en-US": { translation: enUS },
  "zh-CN": { translation: zhCN },
  "zh-HK": { translation: zhHK },
  "ru-RU": { translation: ruRU },
  "tr-TR": { translation: trTR },
  "ja-JP": { translation: jaJP },
  "fr-FR": { translation: frFR },
  "de-DE": { translation: deDE },
  "es-ES": { translation: esES },
  hi: { translation: hiIN },
  "vi-VI": { translation: viVI },
  "ko-KR": { translation: koKR },
  "pl-PL": { translation: plPL },
};

const browserLang = getBrowserLang(); // 自动判断浏览器语言
// console.log("browserLang", browserLang);
const rawLng = browserLang;
const finalLng = Object.keys(resources).includes(transformLangCode(rawLng))
  ? transformLangCode(rawLng)
  : "en-US";

i18n.use(initReactI18next).init({
  resources,
  lng: finalLng,
  fallbackLng: "en-US",
  interpolation: {
    escapeValue: false,
  },
});

//配置语言匹配支持的语言列表
export const useToLang = (lang: string) => {
  // resources的key到supportedLanguages的code的映射关系
  const langMap: Record<string, string> = {
    "de": "de-de",
    "en": "en-us",
    "es": "es-es",
    "fr": "fr-fr",
    "hi": "hi",
    "ja": "ja-jp",
    "ko": "ko-kr",
    "pl": "pl-pl",
    "ru": "ru-ru",
    "tr": "tr-tr",
    "vi": "vi-vi",
    "cn": "zh-cn",
    "hk": "zh-hk",
  };

  return langMap[lang] || null;
}
export const langs = Object.keys(resources);
export default i18n;
